import axios from 'axios'
import Security from './security.js'

export default {
  favorite: {
    base_url: function() {
      return "https://bright-finder.herokuapp.com/api/favorites"
    },

    create: function(favorite, success) {
      axios.post(this.base_url(), { favorite: favorite }, Security.bf_headers(window.bf_api_token)).then(success)
    },

    destroy: function(id, success) {
      axios.delete(this.base_url() + "/" + id, Security.bf_headers(window.bf_api_token)).then(success)
    },

    index: function(success) {
      axios.get(this.base_url(), Security.bf_headers(window.bf_api_token)).then(success)
    },

    update: function(id, favorite, success) {
      axios.delete(this.base_url() + "/" + id, { favorite: favorite }, Security.bf_headers(window.bf_api_token)).then(success)
    }
  },

  inquiry: {
    create: function(api_token, provider_id, success) {
      axios.post("https://bright-finder.herokuapp.com/api/providers/" + provider_id + "/inquiry", { inquiry: { active: true } },{ headers: { "Authorization": api_token } }).then(success)
    }
  },

  list: {
    base_url: function() {
      return "https://bright-finder.herokuapp.com/api/lists"
    },

    create: function(list, success) {
      axios.post(this.base_url(), { list: list }, Security.bf_headers(window.bf_api_token)).then(success)
    },

    destroy: function(list_id, success) {
      axios.delete(this.base_url() + "/" + list_id, Security.bf_headers(window.bf_api_token)).then(success)
    },

    get: function(list_id, success) {
      axios.get(this.base_url() + "/" + list_id, Security.bf_headers(window.bf_api_token)).then(success)
    },

    index: function(success) {
      axios.get(this.base_url(), Security.bf_headers(window.bf_api_token)).then(success)
    },

    update: function(list_id, list, success) {
      axios.delete(this.base_url() + "/" + list_id, { list: list }, Security.bf_headers(window.bf_api_token)).then(success)
    }
  },

  provider: {
    base_url: function() {
      return "https://bright-finder.herokuapp.com/api/providers"
    },

    create: function(api_token, provider, success) {
      axios.post(this.base_url(), { provider: provider }, Security.bf_headers(api_token)).then(success)
    },

    get: function(id, success) {
      axios.get(this.base_url() + "/" + id, Security.bf_headers(window.bf_api_token)).then(success)
    },

    update: function(api_token, provider, success) {
      axios.patch(this.base_url() + "/" + provider.id, { provider: provider }, Security.bf_headers(api_token)).then(success)
    },
  },

  search: {
    base_url: function() {
      return "https://bright-finder.herokuapp.com/api/searches"
    },

    create: function(search, success, error) {
      axios.post(this.base_url(), { search: search }, Security.bf_headers(window.bf_api_token)).then(success).catch(error)
    },

    get: function(id, success) {
      axios.get(this.base_url() + "/" + id, Security.bf_headers(window.bf_api_token)).then(success)
    },

    update: function(id, search, success) {
      axios.patch(this.base_url() + "/" + id, { search: search }, Security.bf_headers(window.bf_api_token)).then(success)
    }
  }
}
